import { AGENTS_ENDPOINTS } from "./agents";
import { AUTH_ENDPOINTS } from "./auth";
import { CORS_ALLOWED_DOMAINS_ENDPOINTS } from "./cors-allowed-domain";
import { ERROR_CAPTURE_ENDPOINTS } from "./error-capture";
import { FILTERS_ENDPOINTS } from "./filters";
import { ILO_SERVERS_ENDPOINTS } from "./ilo-servers";
import { IPMI_SERVERS_ENDPOINTS } from "./ipmi-servers";
import { NETWORK_ENDPOINTS } from "./network";
import { SIP_LOGS_ENDPOINTS } from "./sip-logs";
import { SIP_FRIENDS_ENDPOINTS } from "./sip-friends";
import { SIP_INCOMING_CALL_TEST_ENDPOINTS } from "./sip-incoming-call-test";
import { UPTIME_KUMA_ENDPOINTS } from "./uptimekuma";
import { USER_ENDPOINTS } from "./user";
import { USER_ACTIONS_ENDPOINTS } from "./user-actions";

export const CENTERAL_ERROR_CAPTURE_ENDPOINTS = {
  auth: AUTH_ENDPOINTS,
  error_capture: ERROR_CAPTURE_ENDPOINTS,
  filters: FILTERS_ENDPOINTS,
  user_actions: USER_ACTIONS_ENDPOINTS,
  cors_allowed_domain: CORS_ALLOWED_DOMAINS_ENDPOINTS,
  user: USER_ENDPOINTS,
  uptimekuma: UPTIME_KUMA_ENDPOINTS,
  network: NETWORK_ENDPOINTS,
  sip_logs: SIP_LOGS_ENDPOINTS,
  sip_incoming_call_test: SIP_INCOMING_CALL_TEST_ENDPOINTS,
  sip_friends: SIP_FRIENDS_ENDPOINTS,
  agents: AGENTS_ENDPOINTS,
  ipmi_servers: IPMI_SERVERS_ENDPOINTS,
  ilo_servers: ILO_SERVERS_ENDPOINTS,
}
